module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-1-75.d10a55a6.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-1-75.png
// module id = 2552
// module chunks = 11